import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const clientLogos = [
  {
    name: "Casto House",
    url: "https://customer-assets.emergentagent.com/job_seo-loyalty-expert/artifacts/vvvxgqr7_Untitled%20design%20%282%29.png"
  },
  {
    name: "The Artisan",
    url: "https://customer-assets.emergentagent.com/job_seo-loyalty-expert/artifacts/o2fbjve3_The%20Artisan.png"
  },
  {
    name: "Tendys",
    url: "https://customer-assets.emergentagent.com/job_seo-loyalty-expert/artifacts/rwzeumki_Tendys.png"
  },
  {
    name: "Alain Afflelou",
    url: "https://customer-assets.emergentagent.com/job_seo-loyalty-expert/artifacts/0uajpsfl_Logo-alain-afflelou.svg.png"
  },
  {
    name: "Cecit",
    url: "https://customer-assets.emergentagent.com/job_seo-loyalty-expert/artifacts/usu97zvc_logo-horizontal-cecit-for-light-bg.png"
  }
];

const TrustedBy = () => {
  const { t, i18n } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const isRTL = i18n.language === 'ar';

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="clients"
      className="relative py-20 md:py-24 bg-black border-t border-b border-white/5"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-14">
          <div
            className={`inline-flex items-center gap-3 mb-4 opacity-0 ${
              isVisible ? 'animate-fade-in-up' : ''
            }`}
          >
            <span className="w-12 h-[2px] bg-[#00FFD1]" />
            <span className="text-[#00FFD1] text-sm font-medium tracking-wider uppercase">
              {t('trustedBy.title')}
            </span>
            <span className="w-12 h-[2px] bg-[#00FFD1]" />
          </div>

          <h2
            className={`text-2xl md:text-3xl font-semibold text-white opacity-0 ${
              isVisible ? 'animate-fade-in-up delay-100' : ''
            }`}
          >
            {t('trustedBy.subtitle')}
          </h2>
        </div>

        {/* Logos Grid */}
        <div
          className={`flex flex-wrap items-center justify-center gap-10 md:gap-16 opacity-0 ${
            isVisible ? 'animate-fade-in-up delay-200' : ''
          }`}
        >
          {clientLogos.map((client, index) => (
            <div
              key={client.name}
              className="group relative flex items-center justify-center"
            >
              <img
                src={client.url}
                alt={client.name}
                className="h-12 md:h-16 w-auto max-w-[140px] md:max-w-[180px] object-contain transition-all duration-500 ease-in-out brightness-0 invert opacity-50 group-hover:brightness-100 group-hover:invert-0 group-hover:opacity-100"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
